<template>
  <div class="collapse navbar-collapse text-center" id="sideNavCollapse">
    <div
      class="nav flex-column nav-pills mt-4"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path == '/myhome' }"
        to="/myhome"
        >Dashboard</router-link
      >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path == '/myfeed' }"
        to="/myfeed"
        >My Feed</router-link
      >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path == '/grantsearch' }"
        to="/grantsearch"
        >Search Grants</router-link
      >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path.includes('/mygrants') }"
        to="/mygrants"
        >My Grants</router-link
      >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path == '/userpreferences' }"
        to="/userpreferences"
        >My Profile</router-link
      >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path.includes('/blog') }"
        to="/blog"
        >Blog</router-link
      >
      <router-link
        v-if="$canManageMyAccount($store.getters.user.Permissions)"
        class="nav-link"
        v-bind:class="{ active: $route.path == '/myaccount' }"
        to="/myaccount"
        >My Account</router-link
      >
      <router-link
        v-if="
          $canManageOrganization(
            $store.getters.user.Organization_Id,
            $store.getters.user.Permissions
          ) && !$canManageMyAccount($store.getters.user.Permissions)
        "
        class="nav-link"
        v-bind:class="{ active: $route.path == '/myorganization' }"
        to="/myorganization"
        >My Organization</router-link
      >
      <router-link
        class="nav-link"
        v-bind:class="{ active: $route.path == '/help' }"
        to="/help"
        >Help / FAQs</router-link
      >
      <div
        v-if="
          $canManageGrants(
            $store.getters.user.Account_Id,
            $store.getters.user.Permissions
          ) ||
            $canManageAllAccounts(
              $store.getters.user.Account_Id,
              $store.getters.user.Permissions
            ) ||
            $canManageTemplates($store.getters.user.Permissions)
        "
        class="mt-1 mb-1 ml-3 mr-3"
        style="height: 2px; background-color:lightgray;"
      />
      <router-link
        v-if="
          $canManageGrants(
            $store.getters.user.Account_Id,
            $store.getters.user.Permissions
          )
        "
        class="nav-link"
        v-bind:class="{ active: $route.path == '/managegrants' }"
        to="/managegrants"
        >Manage Grants</router-link
      >
      <router-link
        v-if="
          $canManageAllAccounts(
            $store.getters.user.Account_Id,
            $store.getters.user.Permissions
          )
        "
        class="nav-link"
        v-bind:class="{ active: $route.path.includes('/accountmanagement') }"
        to="/accountmanagement"
        >Manage Accounts</router-link
      >
      <router-link
        v-if="$canManageTemplates($store.getters.user.Permissions)"
        class="nav-link"
        v-bind:class="{ active: $route.path == '/managetemplates' }"
        to="/managetemplates"
        >Manage Templates</router-link
      >
      <router-link
        v-if="$canManageTemplates($store.getters.user.Permissions)"
        class="nav-link"
        v-bind:class="{ active: $route.path == '/manageglossary' }"
        to="/manageglossary"
        >Manage Glossary</router-link
      >
      <router-link
        v-if="$canManageTemplates($store.getters.user.Permissions)"
        class="nav-link"
        v-bind:class="{ active: $route.path == '/managefaq' }"
        to="/managefaq"
        >Manage FAQ</router-link
      >
      <router-link
        v-if="$canManageTemplates($store.getters.user.Permissions)"
        class="nav-link"
        v-bind:class="{ active: $route.path == '/managetutorial' }"
        to="/managetutorial"
        >Manage Tutorials</router-link
      >
      <router-link
        v-if="$canManageBlog($store.getters.user.Permissions)"
        class="nav-link"
        v-bind:class="{ active: $route.path == '/manageblog' }"
        to="/manageblog"
        >Manage Blog</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "SideNav",
  data() {
    return {
      something: ""
    };
  },
  methods: {
    navigateTo(page) {
      if (this.$route.path != "/" + page) {
        this.$router.push(page);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
